import React from "react";
var __jsx = React.createElement;
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';
import { StyledArrow, StyledShadowIconButton } from './BackButton.style';

var BackButton = function BackButton(props) {
  var _props$onClick;

  var _useRouter = useRouter(),
      back = _useRouter.back;

  var intl = useIntl();
  return __jsx(StyledShadowIconButton, {
    onClick: (_props$onClick = props.onClick) !== null && _props$onClick !== void 0 ? _props$onClick : back,
    "aria-label": intl.formatMessage({
      id: 'page.back'
    })
  }, __jsx(StyledArrow, null));
};

export default BackButton;